import Vue from 'vue';
import VueRouter from 'vue-router';
import appRoutes from './routes/profile.js';
import errorRoutes from './routes/error.js';
import qs from 'qs';

const Campaigns = () => import('@/views/Campaign/index.vue');
const ArchivedCampaigns = () =>
  import('@/views/Campaign/AdvCampaign/ArchivedCampaigns.vue');
const TaskStatistics = () =>
  import('@/views/Campaign/BountyCampaign/TaskStatistics.vue');
const Campaign = () => import('@/views/Campaign/BountyCampaign/index.vue');
const CampaignAdd = () => import('@/views/Campaign/CampaignAdd.vue');
const Creatives = () => import('@/views/Advertiser/Creatives.vue');
const Landings = () => import('@/views/Advertiser/Landings.vue');
const Users = () => import('@/views/Campaign/Admin/Users.vue');
const Task = () => import('@/views/Campaign/BountyCampaign/Task.vue');
const TaskAdd = () => import('@/views/Campaign/BountyCampaign/TaskAdd.vue');
const AdZones = () => import('@/views/Publisher/AdZones.vue');
const AdZoneCreate = () => import('@/views/Publisher/AdZoneCreate.vue');
const AdZoneTypes = () => import('@/views/Publisher/AdZoneTypes.vue');
const SiteAdd = () => import('@/views/Publisher/SiteAdd.vue');
const Dashboard = () => import('@/views/Dashboard/index.vue');
const DashboardLogs = () => import('@/views/Dashboard/Admin/Logs.vue');
const Stats = () => import('@/views/Stats/index.vue');
const Payments = () => import('@/views/Payments/index.vue');
const Components = () => import('@/views/Components/index.vue');
const Contacts = () => import('@/views/Contacts/index.vue');
const Tutorial = () => import('@/views/Tutorial/index.vue');
// const Washer = () => import('@/views/Washer/index.vue');
// const WasherTargetForm = () => import('@/views/Washer/TargetForm.vue');

Vue.use(VueRouter);

const routes = [
  ...appRoutes,
  {
    path: '/',
    redirect: 'dashboard',
    hidden: true,
    meta: {
      title: 'dashboard',
      icon: 'menu-monitor'
    }
  },
  {
    path: '/dashboard',
    component: Dashboard,
    name: 'dashboard',
    meta: {
      roles: [
        'bounty-hunter',
        'bounty-manager',
        'advertiser',
        'publisher',
        'advert-admin'
      ],
      title: 'dashboard',
      icon: 'menu-monitor'
    }
  },
  {
    path: '/dashboard/logs',
    component: DashboardLogs,
    name: 'dashboard-logs',
    hidden: true,
    meta: {
      roles: ['advert-admin']
    }
  },
  {
    path: '/campaigns',
    component: Campaigns,
    name: 'campaigns',
    meta: {
      roles: ['bounty-hunter', 'bounty-manager', 'advertiser', 'bounty-admin'],
      title: 'campaigns',
      icon: 'menu-my-campaigns'
    }
  },
  {
    path: '/archived-campaigns',
    component: ArchivedCampaigns,
    name: 'archived-campaigns',
    hidden: true,
    meta: {
      roles: 'advertiser'
    }
  },
  {
    path: '/sites',
    component: AdZones,
    name: 'sites',
    meta: {
      roles: ['publisher'],
      title: 'sites',
      icon: 'sites'
    }
  },
  {
    path: '/campaigns/add',
    component: CampaignAdd,
    hidden: true,
    name: 'campaign-add',
    meta: {
      roles: ['bounty-manager', 'advertiser', 'publisher', 'bounty-admin']
    }
  },
  {
    path: '/creatives',
    component: Creatives,
    name: 'creatives-list',
    meta: {
      roles: ['advertiser', 'advert-admin'],
      title: 'Creatives',
      icon: 'creative-menu'
    }
  },
  {
    path: '/landings',
    component: Landings,
    name: 'landings-list',
    meta: {
      roles: ['advertiser', 'advert-admin'],
      title: 'Landings',
      icon: 'landings'
    }
  },
  {
    path: '/campaigns/:id',
    component: Campaign,
    hidden: true,
    name: 'campaign'
  },
  {
    path: '/campaigns/edit/:id',
    component: CampaignAdd,
    hidden: true,
    name: 'campaign-edit',
    meta: {
      roles: [
        'bounty-manager',
        'advertiser',
        'publisher',
        'bounty-admin',
        'advert-admin'
      ]
    }
  },
  {
    path: '/campaigns/:id/task-add/:type',
    component: TaskAdd,
    hidden: true,
    name: 'task-add',
    meta: {
      roles: ['bounty-manager', 'bounty-admin', 'advert-admin']
    }
  },
  {
    path: '/campaigns/:id/task-edit/:type',
    component: TaskAdd,
    hidden: true,
    name: 'task-edit',
    meta: {
      roles: ['bounty-manager', 'bounty-admin', 'advert-admin']
    }
  },
  {
    path: '/campaigns/:id/:name',
    component: Task,
    hidden: true,
    name: 'campaign-task'
  },
  {
    path: '/campaigns/:id/:name/:taskId/statistics',
    component: TaskStatistics,
    hidden: true,
    name: 'campaign-task-statistics'
  },
  // {
  //   path: '/washer',
  //   component: Washer,
  //   name: 'washer',
  //   meta: {
  //     roles: ['admin'],
  //     title: 'washer',
  //     icon: 'alien'
  //   }
  // },
  // {
  //   path: '/washer/target/new',
  //   component: WasherTargetForm,
  //   name: 'washer-target-form-new',
  //   hidden: true,
  //   meta: {
  //     roles: ['admin']
  //   }
  // },
  // {
  //   path: '/washer/target/:id/edit',
  //   component: WasherTargetForm,
  //   name: 'washer-target-form-edit',
  //   hidden: true,
  //   meta: {
  //     roles: ['admin']
  //   }
  // },
  {
    path: '/users',
    component: Users,
    name: 'users',
    meta: {
      roles: ['admin', 'advert-admin', 'bounty-admin'],
      icon: 'users',
      title: 'users'
    }
  },
  {
    path: '/statistics',
    component: Stats,
    name: 'stats',
    meta: {
      roles: ['advert-admin', 'publisher', 'advertiser'],
      title: 'statistics',
      icon: 'menu-chart'
    }
  },
  // {
  //   path: '/adzones',
  //   component: AdZones,
  //   name: 'sites-and-adzones',
  //   meta: {
  //     roles: ['publisher', 'advertiser'],
  //     title: 'sitesAndAdzones',
  //     icon: 'alien'
  //   }
  // },
  {
    path: '/adzone-create/:id',
    component: AdZoneCreate,
    name: 'create-ad-zone',
    hidden: true,
    meta: {
      roles: ['publisher', 'advertiser'],
      title: 'Create Ad Zone'
    }
  },
  {
    path: '/adzone-create',
    component: AdZoneTypes,
    name: 'adzone-create',
    hidden: true,
    meta: {
      roles: ['publisher', 'advertiser'],
      title: 'AdZone types'
    }
  },
  {
    path: '/site-add',
    component: SiteAdd,
    name: 'site-add',
    hidden: true,
    meta: {
      roles: ['publisher', 'advertiser'],
      title: 'Add website'
    }
  },
  {
    path: '/payments',
    component: Payments,
    name: 'payments',
    meta: {
      roles: ['publisher', 'advertiser', 'bounty-admin', 'bounty-hunter'],
      title: 'payments',
      icon: 'payments'
    }
  },
  {
    path: '/contacts',
    component: Contacts,
    name: 'contacts',
    meta: {
      roles: [
        'publisher',
        'advertiser',
        'admin',
        'bounty-admin',
        'advert-admin',
        'bounty-hunter',
        'bounty-manager'
      ],
      title: 'support',
      icon: 'support'
    }
  },
  {
    path: '/tutorial/:task',
    component: Tutorial,
    name: 'task-tutorial',
    hidden: true,
    meta: {
      roles: [
        'publisher',
        'advertiser',
        'admin',
        'bounty-admin',
        'advert-admin',
        'bounty-hunter',
        'bounty-manager'
      ]
    }
  },
  {
    path: '/components',
    component: Components,
    name: 'components',
    hidden: true,
    meta: {
      roles: ['admin']
    }
  },
  ...errorRoutes
];

function createRouter() {
  const router = new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior: () => ({ y: 0 }),
    linkExactActiveClass: 'is-active',
    linkActiveClass: 'is-active-parent',
    parseQuery(query) {
      const isNumeric = num => {
        return !isNaN(num);
      };
      return qs.parse(query, {
        encode: false,
        ignoreQueryPrefix: true,
        decoder: str => {
          if (str === 'false') return false;
          if (str === 'true') return true;
          if (isNumeric(str)) return +str;
          return decodeURI(str);
        }
      });
    },
    stringifyQuery(query) {
      return Object.getOwnPropertyNames(query).length > 0
        ? '?' + qs.stringify(query, { encode: false })
        : '';
    }
  });

  return router;
}
export default createRouter;
export { routes };
